export default {
    name: 'ContextStore',
    properties: {
        group_id: {},
        id: { required: true },
    },
};
